import React, { useEffect, useState, useRef } from "react";
import { appState } from "../../AppState";
import { Card, CardBody, CardHeader, CardTitle } from 'reactstrap';

import { isMobile, isTablet } from "react-device-detect";
import { Button } from "../Marketing/Button/Button";

export const ToggleSwitch = (props) => {
  return (
    <label className="switch">
      <input type="checkbox" {...props} />
      <span className="slider round" />
    </label>
  )
}

const ButtonDropdown = ({ label, title, icon, className, children, ...props }) => {
  const [stateApp, stateAppActions] = appState();
  const buttonRef = useRef(null);
  const containerRef = useRef(null);

  const handleDocumentClick = (e) => {
    var button = buttonRef?.current;
    var container = containerRef?.current;

    if (button && container && e.target !== container && !container.contains(e.target) && !button.contains(e.target)) {
      props.setIsOpen(!props.isOpen)
    }
  }

  const toggle = () => {
    props.setIsOpen(!props.isOpen);
  }

  useEffect(() => {
    if (!isMobile && !isTablet) {
      props.isOpen ?
        document.addEventListener('click', handleDocumentClick, true) :
        document.removeEventListener('click', handleDocumentClick, true)
    }
  }, [props.isOpen]);

  return (
    <div className={(className || "") + " position-relative"}>
      <Button
        ref={buttonRef}
        className="w-sm-100"
        color={props.color || ""}
        icon={icon || "far fa-plus"}
        icon-pos={props.iconPos || ""}
        sz="md"
        variant={props.variant}
        onClick={toggle}
        style={props.buttonStyle || null}
      >
        {label || ""}
      </Button>
      <div
        ref={containerRef}
        className={(props.isOpen && !isMobile && !isTablet) ? '' : 'd-none'}
        style={{ zIndex: "999", position: "absolute", right: "0px", width: props.cardWidth || "315px" }}
      >
        <Card
          className="card-minimal button-dropdown-card"
          style={{ top: "15px" }}
        >
          <CardHeader className="card-header-minimal" style={{ paddingLeft: "25px", paddingTop: "30px" }}>
            <CardTitle className="card-title-minimal tria-card-title">
              {title}
            </CardTitle>
          </CardHeader>
          <CardBody style={{ paddingLeft: "30px", paddingRight: "35px" }}>
            {children}
          </CardBody>
        </Card>
      </div>
    </div>
  )
}

export { ButtonDropdown };
